import Vue from 'vue'
Vue.directive('required', {
  inserted: function (el) {
    el.innerHTML = el.innerHTML + '<br><small><span class="badge badge-danger">Required</span></small>'
  }
})